import './commonAssets';

import '../common/stylesheets/modules/widgets/testimonials.less';
import '../storyblocks/stylesheets/modules/about/about-us.less';
import '../storyblocks/stylesheets/modules/home/storyblocks-homepage.less';
import '../storyblocks/stylesheets/modules/about/powered-by.less';
import '../storyblocks/stylesheets/modules/home/storyblocks-about-us.less';
import '../storyblocks/stylesheets/modules/shared/storyblocks-hero.less';
import '../storyblocks/stylesheets/modules/shared/team-wrapper-images-and-content.less';
import '../global/tools/mixins.less';


import AppLoader from '../react/AppLoader/AppLoader';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [],
  auxApps: {
    ...NavApps
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
